import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Stylesheets/Monthtimeline.css";

import AOS from "aos";

const timelineData = [
  {
    time: "Policies and Rules",
    icon: "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img39764_IMG.png",
    title: "Introduction to Company Policies and Rules",
    description: [
      "Trainees are introduced to organizational culture, ethics, punctuality, attendance norms, and professional behavior.",
      "Clear emphasis on discipline from day one — late arrivals, irregular attendance, or misconduct are recorded.",
      "Every trainee is expected to follow a professional code of conduct similar to a corporate work environment.",
    ],
    thumbs: [],
    badges: [{ text: "Foundation", color: "primary" }],
  },
  {
    time: "Evaluation",
    icon: "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img81387_IMG.png",
    title: "Trial Session for Trainees",
    description: [
      "Initial evaluation of communication, adaptability, and learning speed.",
      "Helps trainers understand each trainee’s strengths and weaknesses.",
    ],
    thumbs: [],
    badges: [{ text: "Assessment", color: "success" }],
  },
  {
    time: "IDE setup",
    icon: "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img93609_IMG.png",
    title: "Setup of Development Environment",
    description: [
      "Installation of software tools such as Git, IDEs, testing tools, etc.",
      "Understanding of coding standards, version control practices, and workflow management.",
    ],
    thumbs: [],
    badges: [{ text: "Setup", color: "warning text-dark" }],
  },
  {
    time: "Core Foundation",
    icon: "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img55288_IMG.png",
    title: "Foundation in Technology",
    description: [
      "Basics of chosen technology stack (Android, iOS, Backend, Frontend).",
      "Introduction to core programming principles like variables, loops, functions, and debugging.",
    ],
    thumbs: [],
    badges: [{ text: "Learning", color: "info" }],
  },

];

const Month1 = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
    window.scrollTo({ behavior: "smooth", top: 0 });
  }, []);
  return (
    <section
      id="monthtimeline "
      className="min-vh-100 monthtimeline position-relative overflow-hidden"
    >
      {/* Video Background */}

      {/* <div className="home-bg">
        <video loop autoPlay muted playsInline>
          <source src={bg_video} />
        </video>
        <div className="video-overlay"></div>
      </div> */}

      <div className="container text-light position-relative  ">
        <h1 className="text-center py-3 fw-bold mt-5 gradient-text monthtimeline" style={{fontFamily:"'Merriweather', serif"}}>
          Orientation and Foundation
        </h1>
        <div className="timeline">
          {timelineData.map((item, index) => (
            <div className="timeline-row " data-aos="fade-up" key={index}>
              {item.loading ? (
                <div className="timeline-content" data-aos="fade-down">
                  <p className="m-0">Loading...</p>
                </div>
              ) : (
                <>
                  <div
                    className="timeline-time text-light fw-bold "
                    data-aos="zoom-in-up"
                  >
                    {item.time} <small>{item.date}</small>
                  </div>
                  <div className="timeline-content">
                    <img
                      src={item.icon}
                      alt={item.title}
                      className="timeline-icon"
                    />
                    <h4 style={{color:" rgb(7, 223, 252)"}}>{item.title}</h4>

                    {/* Description as <ul> */}
                    <ul>
                      {item.description.map((point, i) => (
                        <li key={i}>{point}</li>
                      ))}
                    </ul>

                    {/* {item.thumbs && item.thumbs.length > 0 && (
                    <div className="thumbs">
                      {item.thumbs.map((src, i) => (
                        <img
                          key={i}
                          className="img-fluid rounded"
                          src={src}
                          alt="Maxwell Admin"
                        />
                      ))}
                    </div>
                  )} */}

                    <div>
                      {item.badges.map((badge, i) => (
                        <span
                          key={i}
                          className={`badge rounded-pill bg-${badge.color} ${
                            i > 0 ? "ms-1" : ""
                          }`}
                        >
                          {badge.text}
                        </span>
                      ))}
                    </div>
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Month1;
